import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import KycInReviewPage from './KycInReviewPage';
import IdvPage from './pages/Idv/IdvPage';
import IdvDocsPage from './pages/IdvDocs/IdvDocsPage';
import IdvDocsSubmittedPage from './pages/IdvDocsSubmitted/IdvDocsSubmittedPage';
import IdvResubmitPage from './pages/IdvResubmit/IdvResubmitPage';
import IdvSubmittedPage from './pages/IdvSubmitted/IdvSubmittedPage';

const KycInReviewRoute: FuseRouteItemType = {
  path: 'in-review',
  element: <KycInReviewPage />,
  auth: AUTH_ROLES.parent, // []
  children: [
    {
      path: 'idv',
      element: <IdvPage />,
    },
    {
      path: 'idv-docs',
      element: <IdvDocsPage />,
    },
    {
      path: 'idv-docs-submitted',
      element: <IdvDocsSubmittedPage />,
    },
    {
      path: 'idv-resubmit',
      element: <IdvResubmitPage />,
    },
    {
      path: 'idv-submitted',
      element: <IdvSubmittedPage />,
    },
    {
      path: 'idv-none',
      element: <IdvSubmittedPage />,
    },
  ],
};

export default KycInReviewRoute;
